import React from 'react';
import { Link } from 'react-router-dom';
// import SearchBar from '../Components/SearchBar'
// import { Form } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import env from '../ENV';
// import swal from '@sweetalert/with-react';
import { connect } from 'react-redux'
import AuthHandlerInstance from '../Classes/AuthHandler'
import { getNotifications } from '../store/actions/masterActions'
// import DropdownFlat from '../Components/DropdownFlat'
// import numberWithCommas from '../Classes/NumberwithComma'
import dateFormater from '../Classes/FormatDateTimeInIST'
// const FILESERVER_ROOT_URL = env.FILE_SERVER_URL;

// function formatDate(date) {
//     var d = new Date(date),
//         month = '' + (d.getMonth() + 1),
//         day = '' + d.getDate(),
//         year = d.getFullYear();

//     if (month.length < 2)
//         month = '0' + month;
//     if (day.length < 2)
//         day = '0' + day;

//     return [day, month, year].join('-');
// }


class ViewAllNotifications extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            select: true,
            currentPage: 1,
            posPerpage: 10000,
            UserId: AuthHandlerInstance.getUserID(),
            open: false,
            selectAll: false,
            checked: [],
            opacity: "",
            multiCollapseIndex: "",
            array1: [

                { value: 1, icon: "file-pdf", notification: " Document PO0143279.pdf has been successfully uploaded.", time: "2mins ago" },
                { value: 2, icon: "file-excel", notification: " Document PO0143279.pdf has been successfully uploaded.", time: "10mins ago" },
                { value: 3, icon: "file", notification: " Document PO0143279.pdf has been successfully uploaded.", time: "1hr ago" },
                { value: 4, icon: "file-excel", notification: " Document PO0143279.pdf has been successfully uploaded.", time: "40mins ago" },
                { value: 5, icon: "file-image", notification: " Document PO0143279.pdf has been successfully uploaded.", time: "52mins ago" },
                { value: 6, icon: "file", notification: " Document PO0143279.pdf has been successfully uploaded.", time: "20mins ago" },
                { value: 7, icon: "file-excel", notification: " Document PO0143279.pdf has been successfully uploaded.", time: "42mins ago" },
                { value: 8, icon: "file-pdf", notification: " Document PO0143279.pdf has been successfully uploaded.", time: "22mins ago" },
                { value: 9, icon: "file-pdf", notification: " Document PO0143279.pdf has been successfully uploaded.", time: "2hrs ago" },
                { value: 10, icon: "file-excel", notification: " Document PO0143279.pdf has been successfully uploaded.", time: "2hrs ago" },
                { value: 11, icon: "file-pdf", notification: " Document PO0143279.pdf has been successfully uploaded.", time: "2hrs ago" },
                { value: 12, icon: "file", notification: " Document PO0143279.pdf has been successfully uploaded.", time: "4hrs ago" },
                { value: 13, icon: "file-image", notification: " Document PO0143279.pdf has been successfully uploaded.", time: "4hrs ago" },
                { value: 14, icon: "file-pdf", notification: " Document PO0143279.pdf has been successfully uploaded.", time: "5hrs ago" },
            ],
            notifications: []
        }

        this.togglebutton = this.togglebutton.bind(this);
    }
    action1() {
        this.setState({ action1: false });
    }
    togglebutton = (Index) => {
        // const { open } = this.state;  
        // this.setState({  
        //     open: !open,  
        // }); 
        var multiCollapseIndex = this.state.multiCollapseIndex

        if (multiCollapseIndex !== Index || multiCollapseIndex === '') {
            this.setState({ multiCollapseIndex: Index })
        }
    }

    handleSorting(a, b) {
        // alert('hi')
        //     var a1 = new Date(a).getTime();
        //     var b1 = new Date(b).getTime();
        //   if(a1<b1)
        //   return 1;
        //   else if(a1<b1)
        //   return -1;
        //   else
        //   return 0;
    }

    componentDidMount = async () => {
        let data = {
            UserId: this.state.UserId,
            currentPage: this.state.currentPage,
            posPerpage: this.state.posPerpage,
        }
        await this.props.getNotifications(data)
        this.setState({ notifications: this.props.notifications.recordsets[0] })
    }

    render() {

        return (
            <div className="Container-fluid pageheight" >
                <div className="Container-fluid p-4" style={{ opacity: this.state.opacity }}>
                    <div className="row pr-4" >
                        <div className="h4 ">Notifications</div>
                        <div className="col-md-6 ">
                        </div>
                        <div className="col xs={last} pt-2" style={{ paddingRight: 20 }}>
                            {/* <SearchBar placeholder="Search" label="Search" btnName="" /> */}
                        </div>
                    </div>
                    <div className="row-md-6 pr-4 " >
                        {/* <div className="sort-notifications"> Sort <FontAwesomeIcon icon={"sort"} onClick={this.handleSorting} color="black" title="sort" size="lg" style={{marginRight:"10px"}} /> </div> */}
                        <div className="col-md-12 notification-contents">

                            {this.state.notifications.map((element, Index) =>

                                <div className="col-md-12 notification-border  pt-2 pb-2   ">

                                    <div>
                                        <Link to={{ pathname: '/', state: { data: element.PurchaseOrderId } }} className="notify"><FontAwesomeIcon icon={element.icon} color="#F20030" title="file" size="lg" style={{ marginRight: "10px" }} />
                                            {element.Message}
                                        </Link>
                                    </div>
                                    <div style={{ marginLeft: "2rem" }}>
                                        <span style={{ fontSize: "11px", color: "#0072CF", marginTop: "-.5rem" }}>
                                            <FontAwesomeIcon icon={"clock"} color="#FFFF75" title="user" size="lg" style={{ marginRight: "10px" }} />{element.CreatedOn[0] ? dateFormater(element.CreatedOn[0]) : ""}</span>
                                    </div>

                                </div>

                            )}
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state) => ({ notifications: state.masterReducer.notifications })
export default connect(mapStateToProps, { getNotifications })(ViewAllNotifications)